export { default } from '@triptyk/ember-modal/services/dialog-layer';
